import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../state'
import * as content from '../../../../content'

/**
 * Displays tenant zones and permitted zone creation or deletion actions.
 */
@ngCore.Component({
  imports: [
    ds.table.Component,
    ds.overlay.confirmation.Component,
    content.admin.modals.zone.Component,
  ],
  selector: 'atn-admin-tenant-page-zones-tab',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.admin.zones.Collection} */
  public readonly zonesEc = ngCore.inject(state.admin.zones.Collection)

  /** @see {@link state.admin.contexts.Feature} */
  private readonly _contextsFeature = ngCore.inject(
    state.admin.contexts.Feature,
  )

  /** @see {@link state.me.Feature} */
  private readonly _meFeature = ngCore.inject(state.me.Feature)

  /** Whether the current admin user can create zones */
  public readonly canCreateZoneSg = ngCore.computed(() =>
    state.admin.portalAccess.ContentActionAccess.canCreateChild({
      context: this._contextsFeature.selectors.tenantContext.asSignal(),
      user: this._meFeature.selectors.currentUser.asSignal(),
    }),
  )

  /** Canonical table input for the zones in the current tenant. */
  public readonly zonesTableConfigSg = ngCore.computed(
    () =>
      ({
        collection: this.zonesEc,
        view: {
          creation: this.canCreateZoneSg(),
          search: true,
          showColumnSettings: false,
          title: 'Zones',
        },
      }) satisfies ds.table.ec.Config.Input<state.admin.zones.TypeParams>,
  )

  /** Name of the zone marked for deletion */
  public zoneNameForDeleteSg = ngCore.computed(
    (
      [deletedZone] = this.zonesEc.plugins.editingPlugin.feature.selectors
        .deletedEntities()
        .asSignal(),
    ) => deletedZone?.name,
  )

  /**
   * Handles the confirmation action for zone deletion.
   */
  public confirmDeletionClickHandler(): void {
    this.zonesEc.plugins.editingPlugin.feature.actions.submit
      .from('Confirmation.Footer.Buttons.Confirm.Clicked')
      .dispatch({ delete: true })
  }

  /**
   * Handles the cancellation action for zone deletion.
   */
  public cancelDeletionClickHandler(): void {
    this.zonesEc.plugins.editingPlugin.feature.actions.discard
      .from('Confirmation.Footer.Buttons.Cancel.Clicked')
      .dispatch({ delete: true })
  }
}
